import { toastr } from 'react-redux-toastr';
import { MANUAL_VOUCHER_SERVICE_TYPE_ENDPOINT } from '../../config/endpoints';
import { 
  FLAG_GETTING_MANUAL_VOUCHER_SERVICE_TYPES,
  GET_MANUAL_VOUCHER_SERVICE_TYPES,
  CLEAR_MANUAL_VOUCHER_SERVICE_TYPES
} from '../types/accounting';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingManualVoucherServiceTypes = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_MANUAL_VOUCHER_SERVICE_TYPES, payload: flag });

const clearManualVoucherServiceTypes = () => (dispatch) =>
  dispatch({ type: CLEAR_MANUAL_VOUCHER_SERVICE_TYPES });

const getManualVoucherServiceTypes = () => async (dispatch) => {
  try {
    dispatch(flagGettingManualVoucherServiceTypes(true));
    const url = MANUAL_VOUCHER_SERVICE_TYPE_ENDPOINT;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const data = await response.json();
    dispatch({ type: GET_MANUAL_VOUCHER_SERVICE_TYPES, payload: data });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingManualVoucherServiceTypes(false));
  }
}

export {
  clearManualVoucherServiceTypes,
  getManualVoucherServiceTypes
}
